var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import colors from '../colors';
import { temporarySweepVariants } from './buttonDashboardStyles';
export var MuiButtonBase = {
    defaultProps: {
        disableRipple: true,
    },
};
var baseTextStyles = {
    padding: 0,
    justifyContent: 'left',
    background: 'transparent',
};
var padding = {
    large: '9px 20px',
    medium: '5px 16px',
    small: '1px 11px',
};
var fontSize = {
    large: '14px',
    medium: '14px',
    small: '12px',
};
export var MuiButton = {
    defaultProps: {
        disableRipple: true,
        disableElevation: true,
    },
    styleOverrides: {
        sizeLarge: '40px',
        sizeMedium: '32px',
        sizeSmall: '24px',
        root: function (_a) {
            var ownerState = _a.ownerState;
            var size = ownerState.size;
            return {
                padding: size ? padding[size] : padding.medium,
                fontSize: size ? fontSize[size] : fontSize.medium,
                border: '1px solid transparent',
                borderRadius: '100px',
                ':disabled': {
                    color: colors.grey[500],
                },
                '.MuiButton-startIcon': {
                    marginRight: '6px',
                },
                '.MuiButton-endIcon': {
                    marginLeft: '6px',
                },
            };
        },
        // filled variant
        contained: {
            fontWeight: 600,
            ':disabled': {
                backgroundColor: colors.grey[120],
            },
        },
        containedPrimary: {
            ':hover': {
                backgroundColor: colors.blue[300],
            },
            ':active': {
                backgroundColor: colors.blue[600],
            },
        },
        containedError: {
            ':hover': {
                backgroundColor: colors.blush[300],
            },
            ':active': {
                backgroundColor: colors.blush[600],
            },
        },
        // outlined variant
        outlined: {
            border: '1px solid',
            borderColor: colors.grey[300],
            color: colors.grey[800],
            backgroundColor: colors.white,
            ':disabled': {
                backgroundColor: colors.grey[120],
                borderColor: colors.grey[300],
            },
            ':hover': {
                backgroundColor: colors.white,
            },
            ':active': {
                backgroundColor: colors.grey[100],
            },
        },
        outlinedPrimary: {
            color: colors.grey[800],
            ':hover': {
                borderColor: colors.grey[800],
            },
        },
        outlinedError: {
            color: colors.blush[500],
            ':hover': {
                borderColor: colors.blush[300],
            },
        },
        //flat variant
        textPrimary: __assign(__assign({}, baseTextStyles), { color: colors.blue[500], ':hover': {
                color: colors.blue[600],
                backgroundColor: 'transparent'
            }, ':active': {
                color: colors.blue[600],
            } }),
        textSecondary: __assign(__assign({}, baseTextStyles), { backgroundColor: 'transparent', color: colors.grey[800], ':hover': {
                color: colors.grey[900],
                backgroundColor: 'transparent'
            }, ':active': {
                color: colors.grey[900],
                backgroundColor: 'transparent'
            }, ':disabled': {
                color: colors.grey[500],
                background: 'transparent',
            } }),
        textError: __assign(__assign({}, baseTextStyles), { color: colors.blush[500], ':hover': {
                color: colors.blush[600],
                backgroundColor: 'transparent',
            }, ':active': {
                color: colors.blush[600],
                backgroundColor: 'transparent',
            } }),
    },
    //link variant
    variants: __spreadArray([
        {
            props: { variant: 'link', color: 'primary' },
            style: __assign(__assign({}, baseTextStyles), { textDecoration: 'underline', color: colors.blue[500], '&:hover': {
                    textDecoration: 'underline',
                    color: colors.blue[600],
                    background: 'transparent',
                }, '&:active': {
                    textDecoration: 'underline',
                    color: colors.blue[600],
                    background: 'transparent',
                }, '&:disabled': {
                    textDecoration: 'underline',
                    color: colors.grey[500],
                    background: 'transparent',
                } }),
        },
        {
            props: { variant: 'link', color: 'error' },
            style: __assign(__assign({}, baseTextStyles), { color: colors.blush[500], '&:hover': {
                    color: colors.blush[600],
                    background: 'transparent',
                }, '&:active': {
                    color: colors.blush[600],
                    background: 'transparent',
                }, '&:disabled': {
                    color: colors.grey[500],
                    background: 'transparent',
                } }),
        }
    ], temporarySweepVariants, true),
};
